import { useState } from "react"

export const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue || "")

  const handleChange = (e) => {
    if (e === "clearState") {
      setValue(() => "")
      return
    }
    if (e.target.type === "file") {
      setValue(() => e.target?.files)
    } else {
      setValue(() => e.target.value)
    }
  }
  return {
    value,
    onChange: handleChange,
  }
}
